import { APP_INITIALIZER, NgModule } from '@angular/core';
import { HTTP_INTERCEPTORS } from '@angular/common/http';
/*
 * Platform and Environment providers/directives/pipes
 */
import { environment } from 'environments/environment';
// App is our top level component
import { AppComponent } from './app.component';
import { APP_RESOLVER_PROVIDERS } from './app.resolver';
import { AppState } from './app.service';
import '../styles/styles.scss';
import { MenuModule } from './components/menu';
import { FooterModule } from './components/footer';
import { fakeBackendProvider } from './helpers/fake-backend';
import { AppRoutingModule } from './app-routing.module';
import { SharedModule } from './shared';
import { CoreModule } from './core';

/**
 * Application wide providers
 */
const APP_PROVIDERS = [
    ...APP_RESOLVER_PROVIDERS,
    AppState,
    fakeBackendProvider
];

/**
 * `AppModule` is the main entry point into Angular2's bootstrapping process
 */
@NgModule({
    bootstrap: [AppComponent],
    declarations: [
        AppComponent
    ],
    /**
     * Import Angular's modules.
     */
    imports: [
        CoreModule,
        SharedModule,
        AppRoutingModule,
        MenuModule,
        FooterModule
    ],
    /**
     * Expose our Services and Providers into Angular's dependency injection.
     */
    providers: [
        environment.ENV_PROVIDERS,
        APP_PROVIDERS
    ]
})
export class AppModule {
}



// WEBPACK FOOTER //
// ./src/app/app.module.ts